var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',{staticClass:"content-grid-card-container"},[_c('div',{staticClass:"content-grid-card-folder"},[_c('v-icon',{attrs:{"color":"yellow lighten-1","size":"65px"}},[_vm._v("mdi-folder")]),_c('div',{staticClass:"subheading font-weight-medium text-truncate mt-2 mb-2 ml-2",staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.name))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }